import { NovaObraScreen } from "@/screens/obras/nova-obra";

/** Thin wrapper — toda lógica fica em screens/obras/nova-obra */
export function NovaObraPage() {
  return <NovaObraScreen />;
}
